import * as React from "react";
import { Input, Tag } from "antd";
import { InputProps } from "antd/lib/input";

interface InputWithMaskProps extends InputProps {
  maskConfig: { mask: string; label: string }[];
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement> | string) => void;
}

export class InputWithMask extends React.Component<InputWithMaskProps> {
  static defaultProps: InputWithMaskProps = { maskConfig: [] };

  handleCheck = (mask: string, checked: boolean) => {
    const { onChange, value, disabled } = this.props;
    if (disabled) {
      return;
    }
    if (typeof onChange !== "function") {
      return;
    }
    let newValue: string;
    if (checked) {
      newValue = `${value}${mask}`;
    } else {
      newValue = value.replace(mask, "");
    }
    onChange(newValue);
  };

  render() {
    const { value = "", onChange, size, maskConfig, ...rest } = this.props;

    return (
      <div>
        <Input onChange={onChange} value={value} size={size} {...rest} />
        {!this.props.disabled && (
          <div style={{ marginTop: 5 }}>
            {maskConfig.map((item) => (
              <Tag.CheckableTag
                onChange={(checked) => this.handleCheck(item.mask, checked)}
                checked={value.includes(item.mask)}
                key={item.mask}
              >
                {item.label}
              </Tag.CheckableTag>
            ))}
          </div>
        )}
      </div>
    );
  }
}
